import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: (search: Record<string, unknown>): { new?: true; edit?: string } => {
    const edit =
      typeof search.edit === "string" && search.edit.trim() !== "" ? search.edit : undefined;
    // `edit` takes priority over `new` (both at once wouldn't make sense).
    if (edit) {
      return { edit };
    }
    if (search.new === true || search.new === "1" || search.new === "true") {
      return { new: true };
    }
    return {};
  },
  component: AdminEmailPage,
});
